const viewHeaderTpl = (settings, viewData, buttons, resources) => {
  // Renderowanie przycisków.
  const renderColumnButtons = (element) => {
    return `${(() => {
      let html = ``;

      if (new RegExp(",").test(element)) {
        html += `<div class="col-auto">
                    <div class="btn-group" role="group">
                        ${(() => {
                          let html = "";
                          const elements = element.split(",");

                          elements.forEach((element, index) => {
                            const button = buttons[element];

                            html += `<button type="button" class="btn btn-primary projects-calendar__header-${element}" title="${button.title}"><i class="${button.icon}"></i>${button.text}</button>`;
                          });

                          return html;
                        })()}
                    </div>
                </div>`;
      } else {
        const button = buttons[element];

        switch (element) {
          case "select":
            html += `<div class="col-auto">
                        <div class="btn-group" role="group">
                            <label for="projects-calendar-header-${element}"  title="${button.title}">
                                <i class="${button.icon} d-none"></i>
                                <input id="projects-calendar-header-${element}" class="projects-calendar__header-${element}" type="text" required>
                            </label>
                        </div>
                    </div>`;
            break;

          case "fullscreen":
            html += `<div class="col-auto">
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-primary projects-calendar__header-${element}" title="${
              settings.projectsCalendarFullScreenMode ? button.enabled.title : button.disabled.title
            }">
                                ${(function ({ projectsCalendarFullScreenMode }) {
                                  if (projectsCalendarFullScreenMode) {
                                    return `<i class="${button.enabled.icon}"></i>`;
                                  } else {
                                    return `<i class="${button.disabled.icon}"></i>`;
                                  }
                                })(settings)}
                            </button>
                        </div>
                    </div>`;
            break;

          default:
            html += `<div class="col-auto">
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-primary projects-calendar__header-${element}" title="${button.title}"><i class="${button.icon}"></i>${button.text}</button>
                        </div>
                    </div>`;
            break;
        }
      }

      return html;
    })()}`;
  };

  // Renderowanie tekstu
  const renderColumnLabels = (element) => {
    return `<div class="col-auto projects-calendar__header-text">
                <span class="projects-calendar__header-text-date lead">${(function () {
                  const resource = resources[settings.projectsCalendarView];
                  let startDate = new Date(viewData[settings.projectsCalendarView].start);
                  let endDate = new Date(viewData[settings.projectsCalendarView].end);
                  const {
                    start = undefined,
                    end = undefined,
                    separator = undefined,
                    differentDay = undefined,
                    differentMonth = undefined,
                    differentYear = undefined,
                  } = resource.headerLabelFormat;
                  let text = ``;

                  if (
                    startDate.toLocaleDateString("pl-PL", { year: "numeric" }) ===
                    endDate.toLocaleDateString("pl-PL", { year: "numeric" })
                  ) {
                    if (
                      startDate.toLocaleDateString("pl-PL", { month: "numeric" }) ===
                      endDate.toLocaleDateString("pl-PL", { month: "numeric" })
                    ) {
                      if (startDate.toLocaleDateString() === endDate.toLocaleDateString()) {
                        text += [
                          start ? startDate.toLocaleDateString("pl-PL", start) : "",
                          separator ? separator : "",
                          end ? endDate.toLocaleDateString("pl-PL", end) : "",
                        ].join(" ");
                      } else {
                        text += [
                          differentDay.start ? startDate.toLocaleDateString("pl-PL", differentDay.start) : "",
                          differentDay.separator ? differentDay.separator : "",
                          differentDay.end ? endDate.toLocaleDateString("pl-PL", differentDay.end) : "",
                        ].join(" ");
                      }
                    } else {
                      text += [
                        differentMonth.start ? startDate.toLocaleDateString("pl-PL", differentMonth.start) : "",
                        differentMonth.separator ? differentMonth.separator : "",
                        differentMonth.end ? endDate.toLocaleDateString("pl-PL", differentMonth.end) : "",
                      ].join(" ");
                    }
                  } else {
                    text += [
                      differentYear.start ? startDate.toLocaleDateString("pl-PL", differentYear.start) : "",
                      differentYear.separator ? differentYear.separator : "",
                      differentYear.end ? endDate.toLocaleDateString("pl-PL", differentYear.end) : "",
                    ].join(" ");
                  }

                  return text;
                })()}</span>
            </div>`;
  };

  // Renderowanie źródeł widoku.
  const renderColumnResources = (element) => {
    return `
            ${(() => {
              // Pokazanie pól formularza Od - Do.
              let html = ``;

              if (
                settings.projectsCalendarView === "timelineRange" ||
                settings.projectsCalendarView === "timelineRangeArea"
              ) {
                let from = new Date(viewData[settings.projectsCalendarView].start)
                  .toLocaleDateString("pl-PL", { dateStyle: "short" })
                  .split(".")
                  .reverse()
                  .join("-");
                let to = new Date(viewData[settings.projectsCalendarView].end)
                  .toLocaleDateString("pl-PL", { dateStyle: "short" })
                  .split(".")
                  .reverse()
                  .join("-");

                html += `
                 <div class="col-12 col-xxl-auto order-1 order-xxl-0">
                     <form id="projects-calendar-form" class="projects-calendar__form" action="/">
                         <div class="input-group">
                             <span class="input-group-text bg-light"><i class="far fa-calendar-alt me-2"></i> Od</span>
                             <input type="text" class="form-control projects-calendar__form-from" aria-label="Data od" value="${from}" required>
                             <span class="input-group-text bg-light"><i class="far fa-calendar-alt me-2"></i> Do</span>
                             <input type="text" class="form-control projects-calendar__form-to" aria-label="Data do" value="${to}" required>
                         </div>
                     </form>
                 </div>`;
              }

              return html;
            })()}
            <div class="col-12 col-xxl-auto order-0 order-xxl-1 mb-3 mb-xxl-0">
                <div class="form-floating d-inline-block">
                    <select class="form-select projects-calendar__header-view" id="projects-calendar-header-view" aria-label="Widok">
                        ${element
                          .split(",")
                          .map((resourcesKey) => {
                            if (resources.hasOwnProperty(resourcesKey)) {
                              const resource = resources[resourcesKey];
                              let selected = settings.projectsCalendarView === resourcesKey ? "selected" : "";

                              return `<option value="${resourcesKey}" data-type="${resource.type}" ${selected}>${resource.label}</option>`;
                            } else {
                              throw new Error(
                                `${resourcesKey}: nie został zdefiniowany w konfiguracji projectsCalendarResources!`
                              );
                            }
                          })
                          .join("")}
                    </select>
                    <label for="projects-calendar-header-view">Widok</label>
                </div>
            </div>`;
  };

  // Renderowanie zawartości kolumn.
  const renderColumnContent = (column) => {
    let html = "";

    settings.projectsCalendarHeader[column].forEach((item, index) => {
      let type = item.split(":")[0];
      let element = item.split(":")[1];

      switch (type) {
        case "buttons":
          html += renderColumnButtons(element);
          break;

        case "texts":
          html += renderColumnLabels(element);
          break;

        case "resources":
          html += renderColumnResources(element);
          break;

        default:
          break;
      }
    });

    return html;
  };

  return `
    ${(({ projectsCalendarHeader }) => {
      let projectsCalendarHeaderLength = Object.keys(projectsCalendarHeader).length;
      let html = ``;

      if (projectsCalendarHeaderLength > 0) {
        html += `
            <div class="row gy-3 gy-xl-0 d-flex align-items-center">
                <div class="col-12 col-xl-4">
                    <div class="row gx-2 align-items-center">${renderColumnContent("left")}</div>
                </div>
                <div class="col-12 col-xl-3 d-flex align-items-center justify-content-start justify-content-xl-center">
                    <div class="row gx-2 align-items-center">${renderColumnContent("center")}</div>
                </div>
                <div class="col-12 col-xl-5 d-flex align-items-center justify-content-start justify-content-xl-end">
                    <div class="row gx-2 align-items-center">${renderColumnContent("right")}</div>
                </div>
            </div>`;
      }

      return html;
    })(settings)}`;
};

export { viewHeaderTpl };
